import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
    selector: "[app-roof-vent]",
    templateUrl: "./roof-vent.component.html",
    styleUrl: "./roof-vent.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofVentComponent {
  x = input(0);
  y = input(0);
  width = input(200);
  height = input(200);
}
